export const app = {
    browser: undefined,
    body: document.body,
    current: undefined,
    cursor: undefined,
    device: undefined,
    engine: undefined,
    footer: undefined,
    init: undefined,
    loading: true,
    loader: undefined,
    mode: undefined,
    time: undefined,
    theme: undefined,
    nav: undefined,
    os: undefined,
    ratio: undefined,
    root: document.documentElement,
    scroll: undefined,
    viewport: undefined,
    virtualscroll: false,
    wrapper: undefined,
    webp: undefined
};

export const colors = {
    white: '#FFF8F5',
    black: '#202020',
    primary: '#53F5CC'
}

export const mouse = {
    x: 0,
    y: 0,
    direction: { x: 0, y: 0 },
    cache: { x: 0, y: 0 },
}

export const menu = {
    id: undefined,
    isOpen: false,
    current: undefined
}

export const navigation = {
    isOpen: false,
    current: undefined
}

export const sidebar = {
    isOpen: false,
    user: undefined,
    menu: undefined
}

export const search = {
    isActive: false,
    current: undefined
}

export const modal = {
    id: undefined,
    isOpen: false,
    current: undefined
}

export const breakpoints = {
    Desktop: 1900,
	Laptop: 1200,
	iPadLandscape: 1024,
	iPadPortrait: 768,
	iPhoneProMax: 428,
    iPhonePlus: 414,
    iPhoneSE: 320,
	iPhone: 375,
};

export const operators = {
    '<=' : 'max-width:',
    '>=' : 'min-width:',
    '≥' : 'min-width:',
    '≤' : 'max-width:', 
    '>' : 'min-width:', 
    '<' : 'max-width:',
}